import axios from "axios"
import { ITyCRequest } from "../../../interfaces/ITyCRequest"

export const ObtenerTyC = async () => {
    let postData = {idTyC: 1,}
    return axios.post(`api/TerminosCondiciones/ObtenerTyC`,postData)
}


export const aceptarTyC = async () => {
    return axios.post('api/TerminosCondiciones/aceptarTyC')
}

export const aceptarTyC2 = async (postData:ITyCRequest) => {
    return axios.post('api/TerminosCondiciones/aceptarTyC',postData)
}
